module.exports = __webpack_public_path__ + "img/other.08e3e504.png";